import React, { memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { Link, useLocation } from 'react-router-dom';
import styles from './ZtAppOne.module.less';
import Rate from '../../components/Rate/Rate';
import ApkButton from '../../components/Button/Button';
import Button from '../../components/Button/Button';
import { CONTEXT } from '../../config';
import { logPostInfo } from '../../actions/log';
import { getQueryString } from '../../utils/utils';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(({ data, logInfo }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const logInfoData = useSelector(selectLogInfo);
  const LOG_ACTION_SOURCE = {
    source: `${logInfo.tag}`,
  };

  const handleSoftCard = useCallback(() => {
    dispatch(
      logPostInfo({
        source_p: `${LOG_ACTION_SOURCE.source}||${getQueryString('ztId', location.search)}`,
        source_pp: logInfoData.source_p,
        ...logInfo,
      }),
    );
  }, [dispatch]);

  return data && data.content && data.content.appInfo ? (
    <div
      className={styles.card}
      data-softtag={
        data.content.appInfo.androidType !== '1'
          ? data.content.appInfo.softID
          : data.content.appInfo.packageName
      }
    >
      <div className={styles.card_logo}>
        <Link
          className={styles.content_line_title}
          to={
            data.content.appInfo.androidType !== '1'
              ? `${CONTEXT}/detail/soft/${data.content.appInfo.softID || ''}/${data.content
                  .bizInfo || '{}'}`
              : `${CONTEXT}/adetail/${data.content.appInfo.packageName || ''}/${
                  data.content.appInfo.versionCode
                }/${data.content.appInfo.bizInfo || '{}'}`
          }
          onClick={() => {
            handleSoftCard();
          }}
        >
          <img className={styles.card_logo_img} src={data.content.appInfo.logoFile} alt="logo" />
        </Link>
        {data.content.appInfo.androidType === '1' && <div className={styles.card_logo_alogo} />}
      </div>
      <div className={styles.card_content}>
        <div className={styles.content_line}>
          <Link
            className={styles.content_line_title}
            to={
              data.content.appInfo.androidType !== '1'
                ? `${CONTEXT}/detail/soft/${data.content.appInfo.softID || ''}/${data.bizInfo ||
                    data.content.appInfo.bizInfo ||
                    '{}'}`
                : `${CONTEXT}/adetail/${data.content.appInfo.packageName || ''}/${
                    data.content.appInfo.versionCode
                  }/${data.content.appInfo.bizInfo || '{}'}`
            }
            onClick={() => {
              handleSoftCard();
            }}
          >
            {data.content.appInfo.softName}
          </Link>
          <div className={styles.content_line_rate}>
            <Rate score={(Number(data.content.appInfo.score) / 20).toFixed(1)} />
          </div>
        </div>
        <div className={styles.content_line}>
          {data.content.appInfo.downloadCount && (
            <span className={styles.content_line_item}>
              {data.content.appInfo.downloadCount}安装
            </span>
          )}
          <span className={styles.content_line_item}>
            版本号：
            <span className={styles.soft_version} title={data.content.appInfo.version}>
              {data.content.appInfo.version}
            </span>
          </span>
          <span className={styles.content_line_item}>
            大小：{data.content.appInfo.installFileSize}
          </span>
        </div>
        <div className={styles.content_line}>
          <span className={styles.content_line_info}>{data.content.appInfo.introduction}</span>
        </div>
      </div>
      <div className={styles.card_button}>
        {data.content.appInfo.androidType === '1' ? (
          <ApkButton
            soft={{ ...data.content.appInfo, bizInfo: data.bizInfo }}
            info={{
              className: styles.soft_btn,
              className_busing: styles.soft_btn_busing,
              className_open: styles.soft_button_open,
            }}
            logInfo={{
              source: `${LOG_ACTION_SOURCE.source}||${getQueryString(
                'ztId',
                location.search,
              )}||${getQueryString('bannerId', location.search) || ''}`,
            }}
          />
        ) : (
          <Button
            soft={{ ...data.content.appInfo, bizInfo: data.bizInfo }}
            info={{
              className: styles.soft_btn,
              className_busing: styles.soft_btn_busing,
              className_open: styles.soft_button_open,
            }}
            logInfo={{
              source: `${LOG_ACTION_SOURCE.source}||${getQueryString(
                'ztId',
                location.search,
              )}||${getQueryString('bannerId', location.search) || ''}`,
            }}
          />
        )}
      </div>
    </div>
  ) : (
    ''
  );
});
